import React, { useState } from 'react';
import styled from 'styled-components';
import BaseButton from './BaseButton';

import { Colors } from '../../../../scss/common/style';

interface Props {
  size?: 'sm' | 'lg';
  onClick?: () => void;
  title?: string;
  isSubmitting?: boolean;
  active?: boolean;
  disabled?: boolean;
  type?: 'button' | 'reset' | 'submit';
  icon?: any;
  vertical?: boolean;
  iconSize?: number;
  margin?: string;
  marginLeft?: string;
}

export default function BorderlessButton({
  onClick,
  title,
  isSubmitting = false,
  active = false,
  disabled = false,
  type,
  icon,
  vertical = false,
  iconSize,
  margin,
  marginLeft,
}: Props): JSX.Element {
  return (
    <StyledButton vertical={vertical} title={title} margin={margin} marginLeft={marginLeft}>
      <BaseButton
        type={type}
        title={title}
        onClick={onClick}
        isSubmitting={isSubmitting}
        disabled={disabled}
        active={active}
        icon={icon}
        iconSize={iconSize}
      />
    </StyledButton>
  );
}

const StyledButton = styled.div`
  border: 0 !important;
  button {
    div {
      display: flex;
      flex-direction: ${(props) => (props.vertical ? 'column' : 'row')};
      align-items: center;
    }
    border: 0 !important;
    display: flex;
    flex-direction: ${(props) => (props.vertical ? 'column' : 'row')};
    align-items: center;
    background-color: transparent;
    border-color: transparent;
    margin: ${(props) => (props.margin ? props.margin : '0px')};
    margin-left: ${(props) => (props.marginLeft ? props.marginLeft : '0px')};
    padding: ${(props) => (props.title == undefined ? '0px' : '5px 9px')};
    color: ${Colors.slateGray};
    &:hover {
      color: ${Colors.darkRed};
    }
    &:active {
      color: ${Colors.darkBrown};
    }
  }
`;
